import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const unlinkTeamFromFulfillmentService = {
  name: "unlinkTeamFromFulfillmentService" as const,
  input: z.object({ teamId: z.string(), fulfillmentServiceTeamId: z.string() }),
  output: z.object({ workflowId: z.string() }),
  description:
    "Start the workflow that unlinks a team from a 3PL fulfillment service and reassigns open fulfillment groups back to the team.",
};

export const watchUnlinkTeamFromFulfillmentServiceProgress = unaryStreamRpc({
  name: "watchUnlinkTeamFromFulfillmentServiceProgress",
  input: z.object({ teamId: z.string(), fulfillmentServiceTeamId: z.string() }),
  output: z.object({
    status: z.enum(["running", "done", "idle"]),
    total: z.number(),
    processed: z.number(),
    failed: z.number(),
  }),
});
